import { render, staticRenderFns } from "./DocumentInformationContent.vue?vue&type=template&id=1c7fece5&scoped=true"
import script from "./DocumentInformationContent.vue?vue&type=script&lang=js"
export * from "./DocumentInformationContent.vue?vue&type=script&lang=js"
import style0 from "./DocumentInformationContent.vue?vue&type=style&index=0&id=1c7fece5&prod&scoped=true&lang=css"
import style1 from "./DocumentInformationContent.vue?vue&type=style&index=1&id=1c7fece5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7fece5",
  null
  
)

export default component.exports